export const colors = {
  red: '#C50124',
  gray: '#555',
  lightgray: '#aaa'
}

export const fonts = {
  default: 'Roboto, Tahoma, Helvetica, Arial, sans-serif',
  alternative: 'Playfair Display, serif',
}